<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Purchase Order" active>

                                <b-row v-if="hasFailedDataPurchaseOrder">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPurchaseOrder.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseOrdersFailed" :fields="fieldsPurchaseOrder" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseOrder" :sort-desc.sync="sortDescPurchaseOrder" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(purchaseOrderDate)="row">
													{{ row.item.purchaseOrderDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(deliveryDateRequest)="row">
													{{ row.item.deliveryDateRequest | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(quotationDate)="row">
													{{ row.item.quotationDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPurchaseOrder.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseOrders" :fields="fieldsPurchaseOrder" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseOrder" :sort-desc.sync="sortDescPurchaseOrder" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(purchaseOrderDate)="row">
													{{ row.item.purchaseOrderDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(deliveryDateRequest)="row">
													{{ row.item.deliveryDateRequest | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(quotationDate)="row">
													{{ row.item.quotationDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Purchase Order Detail" active>

                                <b-row v-if="hasFailedDataPurchaseOrderDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPurchaseOrderDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseOrderDetailsFailed" :fields="fieldsPurchaseOrderDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseOrderDetail" :sort-desc.sync="sortDescPurchaseOrderDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPo)="row">
													{{ Number(row.item.qtyPo).toLocaleString() }}
												</template>
												<template #cell(priceUnit)="row">
													{{ Number(row.item.priceUnit).toLocaleString() }}
												</template>
												<template #cell(subtotal)="row">
													{{ Number(row.item.subtotal).toLocaleString() }}
												</template>
												<template #cell(pricePpn)="row">
													{{ Number(row.item.pricePpn).toLocaleString() }}
												</template>
												<template #cell(amount)="row">
													{{ Number(row.item.amount).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPurchaseOrderDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseOrderDetails" :fields="fieldsPurchaseOrderDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseOrderDetail" :sort-desc.sync="sortDescPurchaseOrderDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPo)="row">
													{{ Number(row.item.qtyPo).toLocaleString() }}
												</template>
												<template #cell(priceUnit)="row">
													{{ Number(row.item.priceUnit).toLocaleString() }}
												</template>
												<template #cell(subtotal)="row">
													{{ Number(row.item.subtotal).toLocaleString() }}
												</template>
												<template #cell(pricePpn)="row">
													{{ Number(row.item.pricePpn).toLocaleString() }}
												</template>
												<template #cell(amount)="row">
													{{ Number(row.item.amount).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderList from '@/models/PurchaseOrder/PurchaseOrderList';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPurchaseOrder: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Purchase Request Number", key: 'purchaseRequestPurchaseRequestNumber', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order Date", key: 'purchaseOrderDate', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date Request", key: 'deliveryDateRequest', sortable: false},
				{"class" : "th-status", "label" : "Purpose", key: 'purpose', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},
				{"class" : "th-status", "label" : "Total Qty", key: 'totalQty', sortable: false},
				{"class" : "th-status", "label" : "Total Amount", key: 'totalAmount', sortable: false},
				{"class" : "th-status", "label" : "Po Status", key: 'poStatus', sortable: false},
				{"class" : "th-status", "label" : "Total Price Ppn", key: 'totalPricePpn', sortable: false},
				{"class" : "th-status", "label" : "Revisi", key: 'revisi', sortable: false},
				{"class" : "th-status", "label" : "Vendor", key: 'vendorCode', sortable: false},
				{"class" : "th-status", "label" : "Quotation Number", key: 'quotationNumber', sortable: false},
				{"class" : "th-status", "label" : "Quotation Date", key: 'quotationDate', sortable: false},
				{"class" : "th-status", "label" : "Ppn", key: 'ppn', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPurchaseOrderDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Code", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty PO", key: 'qtyPo', sortable: false},
				{"class" : "th-status", "label" : "Price (Rp/Unit)", key: 'priceUnit', sortable: false},
				{"class" : "th-status", "label" : "Subtotal (Rp)", key: 'subtotal', sortable: false},
				{"class" : "th-status", "label" : "Ppn", key: 'pricePpn', sortable: false},
				{"class" : "th-status", "label" : "Amount", key: 'amount', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false},
				{"class" : "th-status", "label" : "Percentage Ppn", key: 'percentagePpn', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			purchaseOrders : [],
			purchaseOrdersFailed: [],
			purchaseOrderId : '',
			sortByPurchaseOrder: '',
			sortDescPurchaseOrder: '',
			hasFailedDataPurchaseOrder: false,
			totalFailedPurchaseOrder: 0,
			totalSucceedPurchaseOrder: 0,
			purchaseOrderDetails : [],
			purchaseOrderDetailsFailed: [],
			purchaseOrderDetailId : '',
			sortByPurchaseOrderDetail: '',
			sortDescPurchaseOrderDetail: '',
			hasFailedDataPurchaseOrderDetail: false,
			totalFailedPurchaseOrderDetail: 0,
			totalSucceedPurchaseOrderDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('purchaseorder/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('purchaseorder/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPurchaseOrderForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPurchaseOrderForUpload : async function() {
			let _this = this;
			this.$http.get('purchaseorder/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.purchaseOrders = [];
_this.purchaseOrderDetails = [];


					if (response != null) {
						let result = response.data;
						_this.purchaseOrders = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPurchaseOrder = _this.purchaseOrders.length;

						_this.purchaseOrdersFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPurchaseOrder = true;
						_this.totalFailedPurchaseOrder = 0;
						if(_this.purchaseOrdersFailed == undefined || _this.purchaseOrdersFailed.length === 0) _this.hasFailedDataPurchaseOrder = false;
						if(_this.hasFailedDataPurchaseOrder) _this.totalFailedPurchaseOrder = _this.purchaseOrdersFailed.length;
						_this.purchaseOrderDetails = [];
						_this.purchaseOrderDetailsFailed = [];
						_this.hasFailedDataPurchaseOrderDetail = true;
						_this.totalSucceedPurchaseOrderDetail = 0;
						result.forEach(function(element) {
							_this.purchaseOrderDetails.push(...element.purchaseOrderDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPurchaseOrderDetail = _this.purchaseOrderDetails.length;

							_this.purchaseOrderDetailsFailed.push(...element.purchaseOrderDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.purchaseOrderDetailsFailed == undefined || _this.purchaseOrderDetailsFailed.length === 0) _this.hasFailedDataPurchaseOrderDetail = false;
							if(_this.hasFailedDataPurchaseOrderDetail) _this.totalFailedPurchaseOrderDetail = _this.purchaseOrderDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'purchaseorder/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PurchaseOrder.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPurchaseOrder = new PurchaseOrderFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
